module.exports = "<h1 class=\"title\">You are not currently signed up for GroupBy Enrich.</h1>\n<p class=\"details\">Talk to your account manager to sign up for Enrich.</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/customer-not-found/customer-not-found.page.html
// module id = ./src/app/pages/errors/customer-not-found/customer-not-found.page.html
// module chunks = main